import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../commons/Loading';
import { useAuth } from '../../commons/Auth';
import {
  BtnModalTable,
  BtnOutlineGreen,
  BtnOutlineRed,
  H4Styled,
} from '../../styled-components';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import classnames from 'classnames';
import { createBonus } from '../../lib/fetch/reports';
import moment from 'moment';
import InsuranceTabel from './InsuranceTabel';

function ModalAllIafs({ data, year, fetchPanoramicaInvoicesByMonth }) {
  const [t] = useTranslation('IAF_BY_MONTH');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const [{ newToken, profile = {} } = {}] = useAuth();

  const [modal, setModal] = useState(false);
  const [sentinel, setSentinel] = useState('insurances');

  const [dataForIafsInsurances, setDataForIafsInsurances] = useState([]);

  const [totIafs, setTotIafs] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totInsurances, setTotInsurances] = useState(0);

  const toggle = () => {
    setModal(!modal);
  };

  const confirmPreview = async (bonus) => {
    const { error } = await createBonus({
      newToken,
      bonus: { ...bonus, profileId: data.profileId },
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }
  };

  const handleConfirm = async () => {
    try {
      showLoading();

      if (dataForIafsInsurances.length > 0) {
        await confirmPreview({
          iafType: 'INSURANCES',
          amount: totInsurances,
          date: moment.utc().startOf('day').format(),
          accountability: year,
          insurances: dataForIafsInsurances.map(
            ({
              _id,
              branch,
              policy_code,
              insurance_code,
              start_date,
              end_date,
              gross,
              net,
              shareToInvoice,
              shareToInvoicePerc,
              subAgencyPerc,
              panoramicaShare,
              adminShare,
              customerId,
              admin,
              earnedCommercialShare,
              commercialShare,
              agencyType,
            }) => ({
              _id,
              branch,
              policy_code,
              insurance_code,
              start_date,
              end_date,
              gross,
              net,
              shareToInvoice,
              shareToInvoicePerc,
              subAgencyPerc,
              panoramicaShare,
              adminShare,
              customerId,
              admin,
              earnedCommercialShare,
              commercialShare,
              agencyType,
            })
          ),
        });
      }

      setDataForIafsInsurances([]);
      toggle();
      await fetchPanoramicaInvoicesByMonth(true);

      alert.success(t('COMMON:SUCCESS_UPDATE'));
    } catch (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
    } finally {
      hideLoading();
    }
  };

  useEffect(() => {
    if (modal) {
      let insurances = [];

      for (const month of data.insurances) {
        if (month.insurances && month.insurances.length > 0) {
          insurances = [...insurances, ...month.insurances];
        }
      }

      setTotalCount(insurances.length);
      setDataForIafsInsurances(insurances);

      const sum = [...insurances].reduce(
        (acc, item) => acc + (item.adminShare || 0),
        0
      );
      const sumInsurances = insurances.reduce(
        (acc, item) => acc + (item.adminShare || 0),
        0
      );

      setTotIafs(sum.toFixed(2));
      setTotInsurances(sumInsurances.toFixed(2));
    } else {
      setDataForIafsInsurances([]);
      setTotIafs(0);
      setTotInsurances(0);
      setTotalCount(0);
    }
  }, [modal]);

  return (
    <>
      <div className="flex-check">
        <BtnModalTable
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            toggle();
          }}
        >
          Emetti tutto
        </BtnModalTable>
      </div>

      <Modal isOpen={modal} className="iafs-modal">
        <ModalHeader toggle={toggle}>
          Anteprima Iafs
          <br />
        </ModalHeader>
        <ModalBody>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5 style={{ fontFamily: "'Open Sans', sans-serif" }}>
              Totale da emettere: € {totIafs}
            </h5>
            <h5 style={{ fontFamily: "'Open Sans', sans-serif" }}>
              Elementi da emettere: {totalCount}
            </h5>
          </div>

          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: sentinel === 'insurances' })}
                onClick={() => setSentinel('insurances')}
                style={{ cursor: 'pointer' }}
              >
                Assicurazioni
              </NavLink>
            </NavItem>
          </Nav>

          {sentinel === 'insurances' && dataForIafsInsurances?.length > 0 && (
            <div style={{ marginTop: '10px' }}>
              <InsuranceTabel
                data={dataForIafsInsurances}
                onFilter={() => {}}
                query={{
                  limit: dataForIafsInsurances?.length || 50,
                  offset: 0,
                }}
                total={dataForIafsInsurances?.length}
              />
            </div>
          )}

          {sentinel === 'insurances' && dataForIafsInsurances?.length === 0 && (
            <H4Styled style={{ textAlign: 'center', marginTop: '15px' }}>
              Non ci sono assicurazioni su cui emettere iaf
            </H4Styled>
          )}
        </ModalBody>
        <ModalFooter>
          <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
            {t('COMMON:CANCEL')}
          </BtnOutlineRed>
          <BtnOutlineGreen
            type="button"
            className="uppercase"
            onClick={handleConfirm}
          >
            Conferma IAF
          </BtnOutlineGreen>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalAllIafs;
